import { render } from "./logo.svg?vue&type=template&id=60d946dd"
const script = {}
script.render = render

export default script